import styled from 'styled-components';
import { Drawer, MenuItem } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export const StyledOneLine = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledTypeOption = styled(MenuItem)`
  min-width: ${({ theme }) => theme.spacing(15)};
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const StyledCheckIcon = styled(CheckIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const StyledActionDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    min-width: 35%;
    max-width: 35%;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    background-color: ${({ theme }) => theme.palette.background.paper};
  }
`;
